<template>
	<div>
		<!-- 我的图库 -->
		<form action="" class="w-100 layui-form" method="post">
			<div class="user-info3 w-100 between-center">
				<select name="">
					<option value="">所有分类</option>
				</select>
				<input type="text" class="layui-input" name="" id="" value="" placeholder="请输入产品名称" />
				<div class="btns">
					<input class="layui-btn layui-btn-normal" value="确定" @click="confirm"/>
					<input type="reset" class="layui-btn" value="重置" @click="reset"/>
				</div>
			</div>
		</form>
		<div class="user-info7 w-100">
			<div class="no-content" style="display: flex;justify-content: center;">
				<img src="../../../static/img/no_data5.png">
			</div>
			<ul v-if="false">
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
				<li>
					<a href="">
						<i><img src="../../assets/images/img_3.png"></i>
						<p>HLX-8-4040-15-K12铝型材</p>
						<span>G-5050-15铝</span>
						<em>2021.05.31</em>
					</a>
				</li>
			</ul>
		</div>
		<div class="fanye gray w-100" v-if="false">
			<div class="center-center">
				<ul class="between-center">
					<li><a href="">&lt;</a></li>
					<li><a href="" class="active">1</a></li>
					<li><a href="">2</a></li>
					<li><a href="">3</a></li>
					<li><a href="">4</a></li>
					<li><a href="">5</a></li>
					<li><a href="">6</a></li>
					<li><a href="">&gt;</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		message
	} from '@/common/common.js'
	export default {
		mounted() {
			this.from();
		},
		methods: {
			from() {
				layui.use(['laydate', 'layer', 'form'], function() {
					let laydate = layui.laydate;
					let layer = layui.layer;
					let form = layui.form;

				});
			},
			confirm() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			},
			reset() {
				message({
					message: '功能暂未开放',
					type: 'warning'
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/meGallery.vue